import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IconsService } from 'src/app/shared/services/icons.service';
import { SettlementsService } from 'src/app/services/settlements.service';
import { CatalogsService } from 'src/app/shared/services/catalogs.service';
import { ImageService } from 'src/app/shared/services/image.service';
import { Bill } from 'src/app/models/bill.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: '[app-tr-payments]',
  template: `
    <td class="align-middle" style="font-size: 15px !important;"><strong># {{bill?.id}}</strong></td>
    <td class="align-middle">
      <span class="mb-0" style="font-size: 14px !important;">{{bill?.unit?.name}}</span><br>
      <span class="mb-0 text-sm" style="font-size: 13px;">{{bill?.settlement?.name}}, {{bill?.building?.name}}</span>
    </td>
    <td *ngIf="showLegalEntity" class="align-middle">{{ bill?.settlement?.legal_entity?.business_name || '—' }}</td>
    <!-- td class="text-center align-middle">
      <span class="text-danger" *ngIf="bill?.consumo_lt! < 0"><fa-icon [icon]="icons.faCircleExclamation"></fa-icon></span>
      {{bill?.consumo_lt | number: '1.2-2'}} Lts.
    </td -->
    <td class="text-center align-middle">{{bill?.total | currency: 'USD'}}</td>
    <td class="text-center align-middle">{{bill?.due_date | date: 'dd/MM/yy'}}</td>
    <td class="text-center align-middle" *ngIf="!bill?.status">{{bill?.periodo_fin | date: 'dd/MM/yy'}}</td>
    <td class="text-center align-middle" *ngIf="bill?.status">{{bill?.paid_date | date: 'dd/MM/yy'}}</td>
    <td class="text-center align-middle">
      <span class="badge" [ngStyle]="{ background: getState(bill).color }">{{getState(bill).name}}</span>
      <span class="badge bg-info ms-1" *ngIf="bill?.invoiced">Facturado</span>
      <span class="badge bg-success ms-1" *ngIf="bill?.status">Pagado</span>
    </td>
    <td class="text-end align-middle">
      <div ngbDropdown class="d-inline-block ms-2">
        <button type="button" class="btn btn-link btn-sm text-dark dropdown-toggle py-1" id="dropdownBasic2" ngbDropdownToggle >
          <fa-icon [icon]="icons.faEllipsisVertical" class="m-1"></fa-icon>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
          <button ngbDropdownItem 
            *ngIf="authService.hasPermission('can_edit_bills')"
            [routerLink]="['/pagos/recibos', bill?.bill_id || bill?.id]"
          >
            <fa-icon [icon]="icons.faEye"></fa-icon>
            Consultar recibo
          </button>
          <a ngbDropdownItem 
            href="{{receiptUrl}}/public/{{bill?.pdf}}"
            target="_blank" 
            [disabled]="!bill?.pdf" 
            *ngIf="!bill?.invoiced"
          >
            <fa-icon [icon]="icons.faDownload"></fa-icon>
            Descargar recibo
          </a>
          <button ngbDropdownItem 
            *ngIf="authService.hasPermission('can_delete_bills')&&bill?.state==0"
            (click)="cancelBill(bill)"
          >
            Cancelar recibo
          </button>
          <button ngbDropdownItem 
            *ngIf="authService.hasPermission('can_read_bills') && bill?.status==true"
            (click)="downloadPaymentReceipt(bill)"
          >
            <fa-icon [icon]="icons.faDownload"></fa-icon>
            Descargar pago
          </button>
          
          <button ngbDropdownItem 
            class="btn btn-outline-primary ms-2" 
            *ngIf="!bill?.invoiced&&!bill?.adv"
            routerLink="/invoices/create/{{bill?.id}}"
          >Facturar</button>
          <button ngbDropdownItem 
            (click)="downloadInvoice(bill?.invoice_id)" 
            [disabled]="!bill?.invoiced" *ngIf="bill?.invoiced">
            <fa-icon [icon]="icons.faDownload"></fa-icon>
            Descargar factura
          </button>
        </div>
      </div>
    </td>
  `,
  styleUrls: []
})
export class TrPaymentsComponent {
  @Input() showLegalEntity = false;
  @Input() bill: Bill | null = null;
  @Input() profile: any;
  @Input() permissions: any;
  @Output() updateDate = new EventEmitter<any>();

  receiptUrl: string = environment.RECIBOS_REST_WSPREFIX;
  invoicable: boolean = true;

  constructor(
    private store: SettlementsService,
    public icons: IconsService,
    public catalogs: CatalogsService,
    public images: ImageService,
    public authService: AuthService,
    private toastr: ToastrService
  ) { }

  async downloadPaymentReceipt(bill: any) {
    await this.store.getTransactionByBill(bill.id).subscribe(async (transaction: any) => {
      const img = this.profile ? this.images.buildURL(this.profile.logo) : null;
      const imx: any = img ? await this.images.getBase64ImageFromUrl(img) : '';
      if (this.profile) {this.profile.logo = imx ? `${imx.split(',')[1]}` : '';}

      let payload = {
        bill: bill,
        transaction: transaction,
        profile: this.profile ?? {}
      }

      this.store.downloadPaymentReceipt(payload).subscribe((data: any) => {
        const int8Array = new Uint8Array(data.result.data);
          const blob = new Blob([int8Array], { type: 'application/pdf' });

          var fileURL = window.URL.createObjectURL(blob);
          var link = document.createElement('a');

          link.href = fileURL;
          link.download = data.filename;
          link.click();
      });
    });
  }

  async downloadInvoice(id: any) {
    this.store.getInvoice(id).subscribe((data: any) => {
      const int8Array = new Uint8Array(data.result.data);
      const blob = new Blob([int8Array], { type: 'application/pdf' });
      const fileURL = window.URL.createObjectURL(blob);
      let link: any = document.createElement('a');
      link.href = fileURL;
      link.download = data.filename;
      link.click();
    });
  }

  cancelBill(bill: any) {
    let confirmation = confirm('¿Está seguro de eliminar el recibo?');
    if (!confirmation) {
      return;
    } else {
      this.store.cancelBill(bill.id).subscribe((response: any) => {
        console.log('response', response);
        this.toastr.success('Recibo cancelado con éxito');
      });
    }
  }

  getState(bill: any) {
    return this.catalogs.bill_states.find((state: any) => state.id === bill.state);
  }

  modifyDate(bill: any) {
    this.updateDate.emit(bill);
  }
}
